/** Web URLs typed into the UI: what counts as one, and filling in what was left out. */

/**
 * A URL as typed, made absolute: `example.com/article` becomes
 * `https://example.com/article`. A URL that already names a scheme is left as
 * it is, http included — a publisher may well target a plain http page.
 */
export function withScheme(value: string): string {
  const trimmed = value.trim()
  if (!trimmed || /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)) return trimmed
  return `https://${trimmed}`
}

/**
 * True when the value is an http(s) URL with a host that could exist — a
 * dotted name like `example.com`, or `localhost`. The scheme is filled in
 * first, so a bare `example.com/a` passes.
 */
export function isWebUrl(value: string): boolean {
  let url: URL
  try {
    url = new URL(withScheme(value))
  } catch {
    return false
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return false
  return /^[a-z0-9-]+(\.[a-z0-9-]+)+$/i.test(url.hostname) || url.hostname === 'localhost'
}
